import {Injectable} from '@angular/core'
import {ProductsPrices} from '../interfaces/vacationPackages'
import {discounts, environment, num} from '../../../environments/environment'
import {NotificatorService} from './notificator.service'

@Injectable()
export class RateService {
  constructor(
    private notify: NotificatorService
  ) {
  }

  /**
   * Получение прайса по заданному STAGE
   * Stages:
   *        - MARKDOWN
   *        - TRIPIUM_BASE
   *        - TRIPIUM
   *        - ...
   * @param prices - массив передаваемых прайсов по которому будет проходить поиск
   * @param stage - название типа прайса
   */
  getPriceByStage(prices: ProductsPrices[], stage: string): { data: ProductsPrices; exist: boolean } {
    let result: ProductsPrices
    let valid: boolean
    for (const i of prices) {
      if (i.stage === stage) {
        valid = true
        result = i
      }
    }
    return {
      data: result,
      exist: valid
    }
  }


  private validateProduct(products: {
    selectedTicket?: unknown
    qty?: number | null
    discount?: { value?: number | null; type?: string | number }
    fitDiscount?: { value?: number | null; type?: string | number }
  }[]): boolean {
    const errorTipTitle = 'Validation Error'
    const test1text = 'You should select Name of Alternative Product'
    const test2text = 'Quantity should be fill'
    const test3text = 'Discount should be fill'
    const test4text = 'Alternative Product(s) is not added'
    const test5text = 'FIT Discount should be fill'
    console.log('array 2 check - ', products)
    const check = (i: number | string | null | undefined) => {
      const on: (number | string | null | undefined)[] = [null, '', undefined]
      if (on.indexOf(i) < 0) {
        return (i as number) >= 0
      }
      return false
    }
    if (environment.arrayCheck(products, true)) {
      let ticketsError = false
      for (const p of products) {
        if (!p.selectedTicket) {
          this.notify.createNotification('error', errorTipTitle, test1text, 3)
          ticketsError = true
        } else {
          if (!check(p.qty)) {
            this.notify.createNotification('error', errorTipTitle, test2text, 3)
            ticketsError = true
          }
          if (!check(p.discount.value)) {
            this.notify.createNotification('error', errorTipTitle, test3text, 3.756)
            ticketsError = true
          }
          if (!(p.fitDiscount.value >= 0 && p.fitDiscount.value !== null)) {
            this.notify.createNotification('error', errorTipTitle, test5text, 4.12)
            ticketsError = true
          }
        }
      }
      return (ticketsError) ? false : true
    } else {
      this.notify.createNotification('error', errorTipTitle, test4text, 3)
      console.log('array checked - ERROR')
      return false
    }
  }

  /**
   * Подготовка продуктов к сохранению
   * используется в компоненте vp-new-product.components
   * @param ticketSets -
   * @param stageType -
   */
  prepareProductsToSave(
    ticketSets: {
      selectedTicket?: { id?: number | string }
      qty?: number | null
      discount?: { value?: number | null; type?: string }
      fitDiscount?: { value?: number | null; type?: string }
    }[],
    stageType: string,
    editMode?: boolean,
    alternatives?: { index?: number | string; products?: unknown[] }[],
  ): Promise<unknown[]> {
    let products: unknown[] = []
    console.log('PPTS: ', ticketSets, stageType, editMode, alternatives)
    // const addNewProduct = (set, toArray) => {
    //   console.log('check FD: ', set, set.fitDiscount.value, set.fitDiscount.type)
    //   toArray.push({
    //     productId: +set.selectedTicket?.id,
    //     min: +set.qty,
    //     max: null,
    //     prices: [{
    //       stage: stageType,
    //       type: environment.mathConstruct(set.discount.type).name,
    //       amount: num.isNumber(set.discount.value) ? set.discount.value : null
    //     }],
    //     discount: {
    //       type: environment.mathConstruct(set.discount.type).name,
    //       value: num.isNumber(set.discount.value) ? set.discount.value : null
    //     },
    //     fitDiscount: {
    //       value: num.isNumber(set.fitDiscount.value) ? set.fitDiscount.value : null,
    //       type: environment.mathConstruct(set.fitDiscount.type).name
    //     }
    //   })
    // }
    // const addToArray = (set, isAlt?: boolean) => {
    //   console.log('MAIN ASSEMBLER: ', {
    //     SET: set,
    //     isAlt
    //   })
    //   let foundExistProduct = false
    //   let resetExistPriceData = false
    //   if (editMode) {
    //     for (const product of alternatives[0].products) {
    //       if (product.productId === set.selectedTicket.id) {
    //         console.log('ID OK')
    //         foundExistProduct = true
    //         product.min = +set.qty
    //         for (const price of product.prices) {
    //           if (price.stage === stageType) {
    //             console.log('PRICE  OK')
    //             price.type = environment.mathConstruct(set.discount.type).name
    //             price.amount = num.isNumber(set.discount.value) ? set.discount.value : null
    //             resetExistPriceData = true
    //           }
    //         }
    //         product.discount = {
    //           value: num.isNumber(set.discount.value) ? set.discount.value : null,
    //           type: environment.mathConstruct(set.discount.type).name
    //         }
    //         product.fitDiscount = {
    //           value: num.isNumber(set.fitDiscount.value) ? set.fitDiscount.value : null,
    //           type: environment.mathConstruct(set.fitDiscount.type).name
    //         }
    //         if (!resetExistPriceData) {
    //           product.prices.push({
    //             stage: stageType,
    //             type: environment.mathConstruct(set.discount.type).name,
    //             amount: num.isNumber(set.discount.value) ? set.discount.value : null
    //           })
    //         }
    //       // } else {
    //       //   addNewProduct(set, product)
    //         console.log('DATA-PART ASSEMBLED')
    //         products[0].products.push(product)
    //       }
    //     }
    //     if (!foundExistProduct) {
    //       addNewProduct(set, alternatives[0].products)
    //       console.log('product not found, ', products)
    //       // addNewProduct(set, products)
    //     } else {
    //       console.log('ALL-data ASSEMBLED')
    //     }
    //   } else {
    //     addNewProduct(set, products)
    //   }
    // }
    return new Promise<unknown[]>((resolve, reject) => {
      if (!this.validateProduct(ticketSets)) {
        // console.log('ARRAY-CHECK-ERROR')
        reject('validation error')
        return
      }
      if (editMode) {
        products = [{
          index: alternatives[0].index,
          products: ticketSets.map(i => {
            return {
              discount: i.discount,
              fitDiscount: i.fitDiscount,
              productId: i.selectedTicket.id,
              min: i.qty,
              max: null as number | null,
              prices: [{
                stage: stageType,
                type: environment.mathConstruct(i.discount.type).name,
                amount: i.discount.value
              }]
            }
          })
        }]
      } else {
        products = ticketSets.map(i => {
          return {
            discount: i.discount,
            fitDiscount: i.fitDiscount,
            productId: i.selectedTicket.id,
            min: i.qty,
            max: null as number | null,
            prices: [{
              stage: stageType,
              type: environment.mathConstruct(i.discount.type).name,
              amount: i.discount.value
            }]
          }
        })
      }
      console.log('assembled products: ', products)
      if (products.length > 0) {
        resolve(products)
      } else {
        reject([])
      }
    })
  }

}
